import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import LoginPage from "@/views/pages/login.vue";
import SelectCompanyPage from "@/views/pages/selectCompany.vue";
import adminRouter from "@/router/admin";
import VueScrollTo from "vue-scrollto";
import customerRouter from "./customer";
import { USER_TYPE } from "@/model/user";
import confirmMail from "./confirmMail";
import ForgotPasswordPage from "@/views/pages/forgotPassword.vue";
import ResetPasswordPage from "@/views/pages/resetPassword.vue";
import Index from "@/views/pages/index.vue";

Vue.use(VueRouter);

const baseRouter: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    redirect: (to) => {
      // if (to.name === "home" && store.state.Auth.role === ROLE_ADMIN) {
      //   return { name: "admin.users" };
      // } else if (
      //   to.name === "home" &&
      //   store.state.Auth.role === ROLE_CUSTOMER
      // ) {
      //   return { name: "customer.home" };
      // } else if (
      //   to.name === "home" &&
      //   store.state.Auth.role === ROLE_ADMIN_CUSTOMER
      // ) {
      //   return { name: "admin-customer.customers" };
      // } else if (to.name === "home") {
      //   return { name: "login" };
      // } else {
      //   return { name: to.name };
      // }
      if (store.state.Auth.token) {
        if (store.state.Auth.user_type === USER_TYPE.CUSTOMER) {
          return { name: "customer.home" };
        } else {
          return { name: "admin.dashboard" };
        }
      } else {
        console.log(to);
        return { name: "index" };
      }
    },
  },
  {
    path: "/",
    name: "index",
    meta: {
      pageTitle: "J-SYS",
    },
    component: Index,
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "J-SYS",
    },
    component: LoginPage,
  },
  {
    path: "/select-company",
    name: "select-company",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "J-SYS",
    },
    component: SelectCompanyPage,
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/pages/logout.vue"),
  },
  {
    path: "/forbiden",
    name: "forbiden",
    component: () => import("../views/pages/forbiden.vue"),
  },
  {
    path: "*",
    name: "error",
    component: () => import("../views/pages/error.vue"),
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("../views/pages/notFound.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot.email",
    component: ForgotPasswordPage
  },
  {
    path: "/reset-password/:token",
    name: "forgot.resetPassword",
    component: ResetPasswordPage
  }
];

const routes = [...baseRouter, ...adminRouter, ...customerRouter, ...confirmMail];

const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});
router.beforeEach(async (to, from, next) => {
  store.dispatch("Router/setPreviousRouter", from);
  store.dispatch("Auth/fetchCurrentUser");
  if (to.meta.notRequiredAuth !== undefined) {
    next();
    return;
  }
  if (to.name == "index") {
    next();
    return;
  }
  if (to.name != "login" && to.name != "forgot.email" && to.name != "forgot.resetPassword" && !store.state.Auth.token) {
    next({
      name: "login",
    });
  } else {
    if (to.name === "login" && !store.state.Auth.token) {
      next();
    } else if (to.name === "forgot.email" && !store.state.Auth.token) {
      next();
    } else if (to.matched[0] &&
      to.matched[0].name == "admin" &&
      store.state.Auth.token &&
      store.state.Auth.user_type === USER_TYPE.STAFF &&
      !store.state.Auth.using_company
    ) {
      if(store.state.Auth.userCompanies && store.state.Auth.userCompanies.length == 1) {
        store.dispatch("Auth/setUsingCompany", store.state.Auth.userCompanies[0].id);
        next({
          name: "admin.dashboard",
        });
      } else {
        next({
          name: "select-company",
        });
      }
    } else if ((to.name === "login" || to.name === "forgot.email" || to.name === "forgot.resetPassword") && store.state.Auth.token) {
      if (store.state.Auth.user_type === USER_TYPE.CUSTOMER) {
        next({
          name: "customer.home",
        });
      } else {
        next({
          name: "admin.dashboard",
        });
      }
    } else if (
      to.matched[0] &&
      to.matched[0].meta.allowRole &&
      !to.matched[0].meta.allowRole.includes(store.state.Auth.user_type)
    ) {
      next({
        name: "forbiden",
      });
    } else {
      next()
    }
  }
});

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    // close sidebar when navigate
    const body = document.querySelectorAll("body");
    body && body[0].removeAttribute("class");
    if (to.matched[0].name === 'customer') {
      body[0].setAttribute("class", "customer");
    }

    if (to.matched[1] && (to.matched[1].name === 'customer.message' || to.matched[1].name === 'admin.message')) {
      body[0].setAttribute("class", "customer message");
    }
    to.name != from.name && VueScrollTo.scrollTo({ force: true });
  });
});
export default router;
